import type { WorldDefinition } from '@/world-prototype/types';
import { jacksonvilleHouseWorld } from '@/world-prototype/worlds/jacksonvilleHouse';

export const worldRegistry = {
  [jacksonvilleHouseWorld.id]: jacksonvilleHouseWorld,
} as const satisfies Record<string, WorldDefinition>;

export type WorldId = keyof typeof worldRegistry;

export function getWorld(id: WorldId): WorldDefinition {
  return worldRegistry[id];
}

export const DEFAULT_WORLD_ID: WorldId = 'jacksonville-house';
